import type { ACCESSEligibilityResultCode } from '@/types/registration';
import type { WregStep } from './wregSteps';

const WREG_ELIG_STEP: Record<ACCESSEligibilityResultCode, WregStep> = {
  eligible: 'screener',
  'eligible-pending-diagnosis': 'screener',
  'eligible-switch-participants': 'screener',
  'not-eligible-control-group': 'x-control',
  'not-eligible-already-aligned': 'x-already',
  'not-eligible-not-medicare': 'x-notelig',
  'not-eligible-services': 'x-notelig',
  'not-eligible-diagnoses': 'x-noqualify',
  'not-eligible-clinical-exclusion': 'x-notelig',
  'not-eligible-mismatch': 'x-mismatch',
};

const WREG_ELIG_CODES = Object.keys(WREG_ELIG_STEP) as ACCESSEligibilityResultCode[];

const WREG_ELIG_FALLBACK_STEP: WregStep = 'x-notelig';

const NOTELIG_BODY: Partial<Record<ACCESSEligibilityResultCode, string>> = {
  'not-eligible-not-medicare': 'wreg.x.notelig.medicare',
  'not-eligible-services': 'wreg.x.notelig.services',
};

const NOTELIG_FALLBACK_BODY = 'wreg.x.notelig.clinical';

const isWregEligCode = (code: string): code is ACCESSEligibilityResultCode =>
  Object.prototype.hasOwnProperty.call(WREG_ELIG_STEP, code);

const wregEligStep = (code: string): WregStep => {
  if (isWregEligCode(code)) return WREG_ELIG_STEP[code];
  console.warn(`wreg: unrecognised eligibility result code "${code}", showing ${WREG_ELIG_FALLBACK_STEP}`);
  return WREG_ELIG_FALLBACK_STEP;
};

const wregNoteligBodyKey = (code: string): string =>
  (isWregEligCode(code) ? NOTELIG_BODY[code] : undefined) ?? NOTELIG_FALLBACK_BODY;

const wregEligPending = (code: string): boolean => code === 'eligible-pending-diagnosis';

const wregEligSwitch = (code: string): boolean => code === 'eligible-switch-participants';

export {
  WREG_ELIG_CODES,
  WREG_ELIG_FALLBACK_STEP,
  WREG_ELIG_STEP,
  isWregEligCode,
  wregEligPending,
  wregEligStep,
  wregEligSwitch,
  wregNoteligBodyKey,
};
